module.exports = __webpack_public_path__ + "img/人脸解析分割.4726051b.png";